module.exports = __webpack_public_path__ + "static/img/04.d8f6555e.png";